import { Manager } from '../../domain/Manager';

class ManagerRepository {
  getCurrentManager(): Manager | null {
    throw new Error('ManagerRepository.getCurrentManager is not implemented');
  }
}

export default ManagerRepository;
